import React from 'react';

import Commontyesplastip from './Commontyesplastip';
import Flatninedplastic from './Flatninedplastic';
import Doublesidedplastic from './Doublesidedplastic';


const Commontypesplasticpa = () => {
    return (
        <div>
            <Commontyesplastip />
            <Flatninedplastic />
            <Doublesidedplastic />

        </div>
    );
};

export default Commontypesplasticpa;
